export default __webpack_public_path__ + "static/media/pop_upx2.eaf2d9ef.jpg";